import { getConversationTitle } from "@/api/chat";
import { showChatReadyToast } from "@/components/frontend/chat/showChatReadyToast";
import type { RemoteThreadListAdapter } from "@assistant-ui/react";
import type { NavigateFunction } from "react-router";

import { getStagedRecoveredThreadTitle } from "../adapters/api-thread-list-adapter";

type GenerateTitle = NonNullable<RemoteThreadListAdapter["generateTitle"]>;

export function withChatReadyToast(
    generateTitle: GenerateTitle,
    isOffChat: (remoteId: string) => boolean,
    getNavigate: () => NavigateFunction
): GenerateTitle {
    return async (remoteId, messages) => {
        const recoveredTitle = getStagedRecoveredThreadTitle(remoteId);
        const result = await generateTitle(remoteId, messages);
        if (isOffChat(remoteId)) {
            if (recoveredTitle !== undefined) {
                showChatReadyToast(recoveredTitle, remoteId, getNavigate());
            } else {
                getConversationTitle(remoteId)
                    .then((title) => {
                        if (!isOffChat(remoteId)) return;
                        showChatReadyToast(title, remoteId, getNavigate());
                    })
                    .catch(() => {
                        if (!isOffChat(remoteId)) return;
                        showChatReadyToast(undefined, remoteId, getNavigate());
                    });
            }
        }
        return result;
    };
}
